import React, { useEffect, useState, useRef, useContext } from 'react';
import WeitereLieferstelle from '../Atoms/WeitereLieferstelle';
import Select from 'react-select'
import Input from '../Atoms/Input'
import NumericInput from 'react-numeric-input';
import Radio from '../Atoms/Radio';
import DatePicker, { registerLocale }  from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import de from 'date-fns/locale/de';
import addDays from 'date-fns/addDays'
import calculateBusinessDays from '../Functions/calculateBusinessDays';
import { formatNumbers } from '../Functions/formatNumbers';
import Button from '../Atoms/Button';
import { useSessionStorage } from '../Hooks/useSessionStorage';

import { ProductContext } from '../Context/Context';

import Icon from '../../Images/icon-calendar.svg'
import LKWmit from '../../Images/lkw_mithaenger.svg'
import LKWohne from '../../Images/lkw_ohnehaenger.svg'
import Modal from '../Modal/Modal';
import PrevNext from '../Atoms/PrevNext';


const FirstStep = (props) => {
	
	registerLocale('de', de)

	const {
		settings,
		bestellung,
		setBestellung,
		region,
		step,
		generalPrices,
		error, setError,
		currentPlz, setCurrentPlz
		 } = useContext(ProductContext)	


	//Liefestellen aus Props
	const getLieferstellen = () => { 
		let result = []
		if (Object.keys(bestellung.lieferstellen).length > 0) {
			Object.keys(bestellung.lieferstellen).map(l => result.push(l))
		}
		return result
	}

	const [lieferstellen, setLieferstellen] = useState(getLieferstellen())
	// const [error, setError] = useState(false)
	const [options, setOptions] = useState([])
	const [timeOptions, setTimeOptions] = useState([])
	const [fahrzeugOptions, setFahrzeugOptions] = useState([])
	const [schlauchLaenge, setSchlauchLaenge] = useSessionStorage('no__schlauch', {label: '40 Meter', value: 0})
	const [savedLieferfahrzeug, setSavedLieferfahrzeug] = useSessionStorage('no__lieferfahrzeug', { label: 'Egal', value: 0 })
	const [savedTime, setSavedTime] = useSessionStorage('no__savedtime', { label: 'Ganzer Tag', value: 0 })
	const [selectedTermin, setSelectedTermin] = useSessionStorage('no__termin', 0)
	const [amount, setAmount] = useSessionStorage('no__amount', 500)
	const [showInfo, setShowInfo] = useState(false)
	

	const [date, setDate] = useState(() => {
		const diff = calculateBusinessDays(new Date(), addDays(new Date(), 3))
		let newDate
		switch (diff) {
			case 1:
				newDate = addDays(new Date(), 6)
				break
			case 2:
				newDate = addDays(new Date(), 5)
				break
			case 3:
				newDate = addDays(new Date(), 3)
				break
			default:
				newDate = addDays(new Date(), 3)
		}
		newDate.setHours(7)
		newDate.setMinutes(0)
		return newDate
	})

	const [selectedTerminAuswahl, setSelectedTerminAuswahl] = useSessionStorage('no__terminauswahl', date)

	// Datumswahl
	const [startdate] = useState(() => {
			const diff = calculateBusinessDays(new Date(), addDays(new Date(), 3))
			let newDate
			switch (diff) {
				case 1:
					newDate = addDays(new Date(), 6)
					break
				case 2:
					newDate = addDays(new Date(), 5)
					break
				case 3:
					newDate = addDays(new Date(), 4)
					break
				default:
					newDate = addDays(new Date(), 3)
			}
			// newDate.setHours(7)
			// newDate.setMinutes(0)
			
			return newDate
		}
	)



	//Get Settings
	useEffect(() => {

		if (Object.entries(settings).length) {

			//Schlauch Settings
			setOptions([])
			settings[region.region].schlauch.map(schlauch => {
				const label = `${schlauch.lange_in_m} ${parseFloat(schlauch.preis_bestellung) > 0 ? '(+' + formatNumbers(schlauch.preis_bestellung * 1.19) + ' €)' : ''}`
				return setOptions(prev => {
					return [
						...prev,
						{label: label, value: parseFloat(schlauch.preis_bestellung).toFixed(2)}
					]
				 })
			})

			//Zeitwahl
			
			setTimeOptions([])
			settings[region.region].liefertermine.map(time => {
				const label = `${time.uhrzeit} ${parseFloat(time.liefertermine_aufpreis_entladestelle) > 0 ? '(+' + formatNumbers((parseFloat(time.liefertermine_aufpreis_entladestelle) * 1.19).toFixed(2)) + ' €)' : ''}`
				return setTimeOptions(prev => {
					return [
						...prev,
						{label: label, value: parseFloat(time.liefertermine_aufpreis_entladestelle).toFixed(2)}
					]
				 })
			})

			//Lieferfahrzeug Settings
			setFahrzeugOptions(prev => [
				{label: 'Egal', value: 0},
				{label: `ohne Anhänger ${settings[region.region].ohneHaenger > 0 ? '(+' + (parseFloat(1.19 * settings[region.region].ohneHaenger).toFixed)(2) + ' €)' : ''}`, value: (parseFloat(settings[region.region].ohneHaenger).toFixed)(2)},
			])
			
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settings])


	useEffect(() => {
		region !== false ? setError(prev => false) : setError(prev => 'Bitte haben Sie Verständnis dafür, dass wir in der von Ihnen angegebenen Region leider keine Lieferung vornehmen können. Für Rückfragen kontaktieren Sie uns gerne.')

	}, [region, setError])

	useEffect(() => {
		setLieferstellen(prev => getLieferstellen())
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [bestellung])

	//Aufschläge für schnelle Lieferung

	const firstUpdate = useRef(true)

	useEffect(() => {
		if (firstUpdate.current) {
			firstUpdate.current = false
			return
		}
		
		const businessDays = calculateBusinessDays(new Date(), date)
		const lieferung = settings[region.region].schnelleLieferung

		let value = 0
		lieferung.map(l => { 
			const werktag = l.werktage.split('-')
			// console.log(werktag)
			if (businessDays >= werktag[0] && businessDays <= werktag[1]) {
				// express = true
				value = parseFloat(l.aufpreis_entladestelle)
			}
			return value
		})
			setBestellung(prev => ({
				...prev,
				totals: {
					...prev.totals,
					express: value,
					singleExpress: value
				}
			}))

		// if (businessDays >= normaleLieferung) {
		// 	return
		// }

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [date])

	

	// Schlauchlänge
	const setSchlauch = e => {
		setSchlauchLaenge(prev => ({label: e.label, value: parseFloat(e.value).toFixed(2)}))
		setBestellung(prev => ({
			...prev,
			schlauch: [e.label.split('(',)[0], parseFloat(e.value).toFixed(2)],
			totals: {
				...prev.totals,
				schlauch: parseFloat(e.value)
		}
		}))
	}

	const handleAmountChange = num => {
		setAmount(prev => num)
		return setBestellung(prev => ({
			...prev,
			liefermenge: num,
		}))
	}

	const setTerminOptions = () => {
		if (settings[region.region] && settings[region.region].termin){
			return [
				{
					label: 'Kein Wunschtermin (Lieferung spätestens in ' + bestellung.settings.lieferzeit_max + ' Werktagen)',
					value: 0,
				},
				{
					label: `Wunschtermin (+${formatNumbers(generalPrices.wunschtermin * 1.19)} €)`,
					value: generalPrices.wunschtermin,
				},
			]
		} else { 
			return [
				{
					label: 'Kein Wunschtermin (Lieferung spätestens in ' + bestellung.settings.lieferzeit_max + ' Werktagen)',
					value: 0,
				},
			]
		}
	}

	const setLieferfahrzeug = e => {
		setSavedLieferfahrzeug(prev => ({label: e.label, value: parseFloat(e.value).toFixed(2)}))
		setBestellung(prev => ({
			...prev,
			lieferfahrzeug: [e.label, parseFloat(e.value).toFixed(2)],
			totals: {
				...prev.totals,
				lieferfahrzeug: parseFloat(e.value).toFixed(2)
			}
		}))
	}

	const setTime = e => {
		setSavedTime(prev => ({ label: e.label, value: parseFloat(e.value).toFixed(2) }))
		
		setBestellung(prev => ({
			...prev,
			totals: {
				...prev.totals,
				termin: parseFloat(e.value)
			},
			wunschtermin: {
				...prev.wunschtermin,
				uhrzeit: [e.label.split('(+').length > 1 ? e.label.split('(+')[0] : e.label, parseFloat(e.value).toFixed(2)],
			}
			
		}))
	}

	const setTermin = e => {

		date.getDay() === 6 && setDate( addDays(new Date(), 5) )
		date.getDay() === 7 && setDate(addDays(new Date(), 4))

		

		setBestellung(prev => ({
			...prev,
			totals: {
				...prev.totals,
				wunschtermin: e.target.value === "0" ? 0 : parseFloat(e.target.value),
				termin: e.target.value === "0" ? 0 : prev.totals.termin,
				express: e.target.value === "0" ? 0 : parseFloat(settings[region.region].schnelleLieferung[0].aufpreis_entladestelle),
			},
			wunschtermin: {
				...prev.wunschtermin,
				express: settings[region.region].schnelleLieferung[0].aufpreis_entladestelle,
				datum: e.target.value === "0" ? false : date,
				value: e.target.value === "0" ? 0 : e.target.value,
				uhrzeit: e.target.value === "0" ? '' : prev.wunschtermin.uhrzeit
			}
		}))
		
		setSelectedTerminAuswahl(prev => e.target.value === "0" ? false : date)
		setSelectedTermin(prev => e.target.value)
	}

	const setTerminBestellung = e => {
		
		let expressPreis = 0

		const businessDays = calculateBusinessDays(new Date(), e)
		const schnelleLieferung = settings[region.region].schnelleLieferung
		const wunschtermin = generalPrices.wunschtermin


		schnelleLieferung.map(lieferung => { 
			const days = lieferung.werktage.split('-')
			if (businessDays <= parseInt(days[1]) && businessDays >= parseInt(days[0])) {
				return expressPreis = lieferung.aufpreis_entladestelle
			}
			return expressPreis
		})

		setBestellung(prev => ({
			...prev,
			wunschtermin: {
				...prev.wunschtermin,
				datum: e,
				value: wunschtermin,
				express: expressPreis
			}
		}))
	}

	const handleDatePicker = (d) => { 
		
		setDate(prev => d)
		setBestellung(prev => ({
			...prev,
			wunschtermin: {
				...prev.wunschtermin,
				express: settings[region.region].schnelleLieferung
			}
		}))
		
		setSelectedTerminAuswahl(d)
		setTerminBestellung(d)

	}

	const isWeekday = (d) => {
		const day = d.getDay();
		return day !== 0 && day !== 6;
	};
	
	const addLieferstelle = () => {
		setBestellung(prev => ({
			...prev,
			anzahlLieferstellen: prev.anzahlLieferstellen + 1,
			
		}))
		setLieferstellen(prev => ([
			...prev,
			['A' + (Math.floor(Math.random()*999))]
		]))
	}

	const changeAmount = e => { 
		setCurrentPlz(prev => e.target.value)
	}

	const changeAmountBlur = e => { 
		setCurrentPlz(prev => e.target.value)
	}


	const isButtonShowing = () => { 

		let showButton = false

		if (currentPlz !== "" && currentPlz.length === 5 && !error && bestellung.liefermenge > 0 &&	bestellung.schlauch && bestellung.lieferfahrzeug.length > 0) { 
				showButton = true
		}

		if (bestellung.anzahlLieferstellen > 1 && currentPlz && bestellung.liefermenge > 0 &&	bestellung.schlauch && bestellung.lieferfahrzeug.length > 0){
			Object.values(bestellung.lieferstellen).map(l => {
				if (!l.plz || l.plz.length < 5) { showButton = false }
				if (l.liefermenge < 500) { showButton = false }
				return l
			})
				
		}

		return showButton
	}


	return (
		<div className="no__flexcontent">
			<div className="no__halfwidth">
				<Input
					handleBlur={changeAmountBlur}
					id='plz'
					type='number'
					required={true}
					disabled={false}
					changeEvent={true}
					value={currentPlz}
					label='PLZ'
					handleChange={e => changeAmount(e)}
				/>
				{/* Fehler wenn kein Postleitzahlentreffer */}
				{error &&
					<p className="error">{error}</p>
				}
			</div>
			{region.region && !error &&
				<div className="no__input-group">
					<label>Lieferumfang in Litern*</label>
					<NumericInput
						className="no__input-number"
						value={amount}
						min={500}
						step={500}
						precision={0}
						format={num => num + ' L'}
						size={5}
						mobile
						required
						onFocus={(e) => e.target.blur()}
						onChange={handleAmountChange}
					/>
				</div>
			}
			{region.region && bestellung.liefermenge > 0 && !error && <div className="no__flexcontent">
				<label>
					Schlauchlänge
					<Select
						className="no__dropdown"
						onChange={setSchlauch}
						options={options}
						placeholder={"Schlauchlänge"}
						noOptionsMessage={() => 'Kein Treffer'}
						defaultValue={schlauchLaenge}
					/>
				</label>
				<label>
					Lieferfahrzeug*
					<Select
						className="no__dropdown"
						onChange={setLieferfahrzeug}
						defaultValue={savedLieferfahrzeug}
						options={fahrzeugOptions}
						placeholder={"Lieferfahrzeug"}
						noOptionsMessage={() => 'Kein Treffer'}
					/>
					<div className="fahrzeug__legende">
						<div className="no__legende">
							<img src={LKWmit} width="78" style={{width: '78px!important'}} alt="Egal" />
							{/* <img src={LKWohne}  width="47" alt="Egal" /> */}
							<p>Größe egal</p>

						</div>
						<div className="no__legende">
							<img src={LKWohne} style={{width: '47px!important'}} alt="ohne Anhänger" />
							<p>Ohne Anhänger</p>
						</div>
					</div>
				</label>

				{/* Wunschtermin */}

				
				<div className="no__wunschtermin">
					<label className="no__flex-row">Ihr Wunschtermin <span className="no__infoicon" onClick={() => setShowInfo(true)}>i</span></label>
					<Radio
						// title="Ihr Wunschtermin"
						name='wunschtermin'
						options={setTerminOptions()}
						required={true}
						handleChange={setTermin}
						selected={selectedTermin}
					/>
					{bestellung.wunschtermin && bestellung.wunschtermin.datum && !error &&
						<div className="no__datepicker">
							<div className="no__datepicker-wrapper">
								<DatePicker
									dateFormat="dd.MM.yyyy"
									onChange={handleDatePicker}
									selected={new Date(selectedTerminAuswahl)}
									locale="de"
									minDate={startdate}
									maxDate={addDays(new Date(), parseInt(bestellung.settings.lieferzeit_max))}
									filterDate={isWeekday}
								/>
								<img src={ Icon } alt="Kalender" className="no__icon"/>
							</div>
							<label>
								Wunschzeitraum
								<Select
									className="no__dropdown"
									onChange={setTime}
									defaultValue={savedTime}
									options={timeOptions}
									placeholder={"Lieferzeit"}
									noOptionsMessage={() => 'Kein Treffer'}
								/>
							</label>
					</div>
					}
					{showInfo && <Modal
						handleClose={() => setShowInfo(false)}
						type="no__info"
					>
						Wenn Sie eine Express-Bestellung benötigen, rufen Sie uns bitte unter folgender Hotline an: <a href={`tel:${bestellung.telefon}`}>{bestellung.telefon}</a>
					</Modal>}
				</div>
				<div className="no__lieferstellen">
					<p><strong>Weitere Lieferstellen</strong> (jeweils {formatNumbers(generalPrices.lieferstelle * 1.19)} €)</p>
					
					{
						lieferstellen.map((lieferstelle, index) => {
							// console.log(lieferstelle, index)
							return (
								<WeitereLieferstelle
									key={lieferstelle}
									region={region}
									number={index + 2}
									settings={settings}
									unique={lieferstelle}
									bestellung={bestellung}
									handleUpdate={setBestellung}
									api={props.api}
									time={savedTime}
								/>
							)
						})
					}
					<Button
						title='Lieferstelle hinzufügen'
						click={addLieferstelle}
						className="no__secondary"
					/>
				</div>
			</div>}
			<div className="no__fullwidth">
					<p className="small__text">* Pflichtfeld</p>
				<PrevNext
					setStep={props.setStep}
					step={step}
					disabled={!isButtonShowing()}
				/>
					{/* <Button click={props.next} title="Weiter" disabled={!isButtonShowing() } className="no__primary fixed__button" /> */}
				
				</div>
		</div>
	)
}

export default FirstStep